import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RouteQueryParams {
    public static Address = 'address';
    public static Email = 'email';
    public static TargetUrl = 'targetUrl';
    public static Token = 't';

    public static Skip = 'skip';
    public static Take = 'take';
    public static SortColumn = 'sortColumn';
    public static SortDirection = 'sortDirection';
}
